import { Component, Input, Output, EventEmitter, ViewChild, AfterViewInit, OnInit } from '@angular/core';
import { EmployeesListModel } from '../employees-list.model';
import { UntypedFormControl } from '@angular/forms';
import { startWith } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';

@Component({
    selector: 'employee-multi-select',
    templateUrl: './employee-multi-select.component.html',
    styleUrls: ['./employee-multi-select.component.scss'],
    standalone: false
})
export class EmployeeMultiSelectComponent implements AfterViewInit, OnInit {
  @Input() empleados: EmployeesListModel[] = [];
  @Input() selectedIds: number[] = [];
  @Output() selectedIdsChange = new EventEmitter<number[]>();

  searchControl = new UntypedFormControl('');
  filteredEmpleados: EmployeesListModel[] = [];
  pagedEmpleados: EmployeesListModel[] = [];

  pageSize = 10;
  pageIndex = 0;

  @ViewChild(MatPaginator,{static: false}) paginator: MatPaginator;

  ngOnInit() {
    this.filterEmpleados('');
    this.searchControl.valueChanges.pipe(
      startWith(''),
    ).subscribe(value => {
      this.filterEmpleados(value);
      this.pageIndex = 0;
      this.updatePagedEmpleados();
    });
  }

  ngAfterViewInit() {
    this.updatePagedEmpleados();
  }

  filterEmpleados(value: string) {
    const filterValue = value != null ? value.toLowerCase() : '';
    this.filteredEmpleados = this.empleados.filter(emp =>
      emp.name.toLowerCase().includes(filterValue)
    );
    this.updatePagedEmpleados();
  }

  updatePagedEmpleados() {
    const start = this.pageIndex * this.pageSize;
    const end = start + this.pageSize;
    this.pagedEmpleados = this.filteredEmpleados.slice(start, end);
  }

  onPageChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.updatePagedEmpleados();
  }

  toggleEmpleado(id: number) {
    if (this.selectedIds.includes(id)) {
      this.selectedIds = this.selectedIds.filter(eid => eid !== id);
    } else {
      this.selectedIds = [...this.selectedIds, id];
    }
    this.selectedIdsChange.emit(this.selectedIds);
  }

  selectAll() {
    this.selectedIds = this.filteredEmpleados.map(e => e.uid);
    this.selectedIdsChange.emit(this.selectedIds);
  }

  clearAll() {
    this.selectedIds = [];
    this.selectedIdsChange.emit(this.selectedIds);
  }
  public trackByIndex(i: number) { return i; }

}
